import { CAMPAIGNS_TOOLTIP_CLASS } from './constants';
import { CampaignName, CampaignNamesWrapper } from './styled';

export type CampaignsTooltipProps = {
  campaignNames: string[];
};

const CampaignsTooltip = ({ campaignNames }: CampaignsTooltipProps): JSX.Element => (
  <CampaignNamesWrapper className={CAMPAIGNS_TOOLTIP_CLASS} data-testid="campaignsNameWrapper">
    {campaignNames.map((campaignName, index) => (
      <CampaignName data-testid="campaignName" key={`${campaignName}_${index}`}>
        {campaignName}
      </CampaignName>
    ))}
  </CampaignNamesWrapper>
);

export default CampaignsTooltip;
